import { useEffect } from "react";

/**
 * Sets the browser tab title.
 * @param {string} title - e.g. "Settings" → tab shows "Fluvo - Settings"
 */
export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `Fluvo - ${title}` : "Fluvo";
    return () => {
      document.title = "Fluvo";
    };
  }, [title]);
}
